import { __decorate } from "tslib";
import Component from "vue-class-component";
import ReactiveComponent from "../components/ReactiveComponent";
import Task from "@/services/task";
import TemplateContent from "@/components/template/TemplateContent.vue";
import CompetitionForm from "@/components/CompetitionForm.vue";
import { Prop } from "vue-property-decorator";
import { parse } from "date-fns";
let VideoEdit = class VideoEdit extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.name = "";
        this.location = "";
        this.link = "";
        this.date = null;
        this.boards = Array();
        this.competitionQuery = { competitions: [] };
        this.competitionTask = Task.idle();
        this.submitTask = Task.idle();
    }
    created() {
        const idNumber = Number(this.id);
        if (idNumber == null || Number.isNaN(idNumber)) {
            console.log("Invalid id prop");
            return;
        }
        this.subscribeQuery({
            tag: "competition",
            options: {
                query: require("@/apollo/queries/competitionEdit.graphql"),
                variables: { id: idNumber }
            },
            onTask: task => {
                this.competitionTask = task;
                if (task.isSuccessful) {
                    this.competitionQuery = task.data;
                    this.name = this.competitionQuery.competitions[0].name;
                    this.location = this.competitionQuery.competitions[0].location;
                    this.link =
                        this.competitionQuery.competitions[0].registration_link || "";
                    this.date = {
                        start: parse(this.competitionQuery.competitions[0].date_start),
                        end: parse(this.competitionQuery.competitions[0].date_end)
                    };
                    this.boards = this.competitionQuery.competitions[0].boards_competitions.map(it => it.board.id);
                }
            }
        });
    }
    submit() {
        const competitionsListQuery = require("@/apollo/queries/competitionsList.graphql");
        this.subscribeMutation({
            tag: "submit",
            options: {
                mutation: require("@/apollo/mutations/editCompetition.graphql"),
                variables: {
                    id: this.competitionQuery.competitions[0].id,
                    name: this.name,
                    location: this.location,
                    link: this.link,
                    start: this.date.start,
                    end: this.date.end,
                    boards: this.boards.map(it => ({
                        board_id: it,
                        competition_id: this.competitionQuery.competitions[0].id
                    }))
                },
                update: (store, { data }) => {
                    try {
                        const competitionsListData = store.readQuery({ query: competitionsListQuery });
                        const competition = data.update_competitions.returning[0];
                        const index = competitionsListData.competitions.findIndex(it => it.id == competition.id);
                        if (index >= 0) {
                            competitionsListData.competitions[index] = competition;
                        }
                        else {
                            competitionsListData.competitions.push(competition);
                        }
                        store.writeQuery({
                            query: competitionsListQuery,
                            data: competitionsListData
                        });
                    }
                    catch (e) {
                        console.log("Failed to update cache after update_competitions mutation");
                    }
                }
            },
            onTask: task => {
                this.submitTask = task;
                if (task.isSuccessful) {
                    this.$router.push({ name: "competitions_list" });
                }
            }
        });
    }
};
__decorate([
    Prop([String, Number])
], VideoEdit.prototype, "id", void 0);
VideoEdit = __decorate([
    Component({
        components: { CompetitionForm, TemplateContent }
    })
], VideoEdit);
export default VideoEdit;
